export default __webpack_public_path__ + "static/platform-hero-3878597126ee4b96518fe414bb923c5d.webp";